import Alpine from 'alpinejs'
import interceptorPlugin from './js/interceptor-alpine-plugin.js'
Alpine.plugin(interceptorPlugin)
